import { fromAPI } from "@cur8/rich-entity";
import { skipToken, useQuery } from "@tanstack/react-query";
import { APIClient } from "lib/api/client";
import { useAPIClient } from "render/context/APIContext";
import { ExtractBody, ExtractKey, QueryOptions } from "typings/query";

export function useVisitMeasurementsQuery<T = Body>({
  patientId,
  visitId,
  options = {},
}: {
  patientId: string | undefined;
  visitId: string | undefined;
  options?: QueryOptions<Body, Key, T>;
}) {
  const apiClient = useAPIClient();

  return useQuery({
    queryKey: queryKey(patientId, visitId),
    queryFn:
      patientId && visitId ? queryFn(apiClient, patientId, visitId) : skipToken,
    staleTime: Infinity,
    ...options,
  });
}

export const queryKey = (
  patientId: string | undefined,
  visitId: string | undefined
) => ["visit-measurements", patientId, visitId];

const queryFn =
  (apiClient: APIClient, patientId: string, visitId: string) => async () => {
    const dto = await apiClient.measurement.fetchVisitMeasurements(
      patientId,
      visitId
    ).result;
    return fromAPI.toVisitMeasurementSummary(dto);
  };

type Body = ExtractBody<typeof queryFn>;
type Key = ExtractKey<typeof queryKey>;
